module.exports = __webpack_public_path__ + "static/media/HowToAdbop_Desktop_SV_2.02f498f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/HowToAdbop_Desktop_SV_2.png
// module id = 580
// module chunks = 0